// Tiny Web Audio synth — no external assets, lazy-init, persisted toggle.

const STORAGE_KEY = "arena.sound.enabled";

let ctx = null;
let master = null;

function ensureCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    ctx = new C();
    master = ctx.createGain();
    master.gain.value = 0.18;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function isSoundEnabled() {
  try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
}

export function setSoundEnabled(on) {
  try { localStorage.setItem(STORAGE_KEY, on ? "1" : "0"); } catch {}
  if (on) ensureCtx();
}

function tone({ freq, dur = 0.18, type = "sine", attack = 0.005, release = 0.08, gain = 1, slideTo }) {
  if (!isSoundEnabled()) return;
  const c = ensureCtx();
  if (!c) return;
  const t = c.currentTime;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t + dur);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.7 * gain, t + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur + release);
  osc.connect(g).connect(master);
  osc.start(t);
  osc.stop(t + dur + release + 0.05);
}

function chord(freqs, opts = {}) {
  freqs.forEach((f, i) => setTimeout(() => tone({ ...opts, freq: f }), i * 18));
}

export const sfx = {
  open:   () => tone({ freq: 380, slideTo: 720, dur: 0.18, type: "triangle", gain: 0.7 }),
  win:    () => chord([523.25, 659.25, 783.99], { dur: 0.22, type: "triangle", gain: 0.9 }),
  bigWin: () => {
    chord([523.25, 659.25, 783.99, 1046.5], { dur: 0.26, type: "triangle", gain: 1.0 });
    setTimeout(() => chord([783.99, 1046.5, 1318.5], { dur: 0.30, type: "triangle", gain: 0.9 }), 180);
  },
  loss:   () => tone({ freq: 320, slideTo: 140, dur: 0.32, type: "sawtooth", gain: 0.6 }),
  ach:    () => {
    tone({ freq: 880,  dur: 0.12, type: "triangle", gain: 0.8 });
    setTimeout(() => tone({ freq: 1174.66, dur: 0.14, type: "triangle", gain: 0.8 }), 100);
    setTimeout(() => tone({ freq: 1568,    dur: 0.22, type: "triangle", gain: 0.9 }), 220);
  },
  levelUp: () => {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) =>
      setTimeout(() => tone({ freq: f, dur: 0.18, type: "triangle", gain: 0.9 }), i * 110)
    );
  },
  tap:    () => tone({ freq: 1200, dur: 0.04, type: "square", gain: 0.25 }),
  alert:  () => tone({ freq: 660, slideTo: 980, dur: 0.12, type: "square", gain: 0.5 }),
};
